import { createFileRoute } from '@tanstack/react-router'
import { GitFork } from 'lucide-react'
import { z } from 'zod'
import { ProvenanceScreen } from '@/screens/investigate/SCR-016-provenance'

export const Route = createFileRoute('/_app/w/$ws/provenance')({
  staticData: { screen: { id: 'SCR-016', title: 'Provenance graph', group: 'Investigate', perm: 'trace.read', order: 7, description: 'From source to memory to delivery: where every fact came from and where it went.', icon: GitFork } },
  validateSearch: z.object({
    root_kind: z.enum(['memory', 'manifest']).optional().catch(undefined),
    root_id: z.string().max(200).optional(),
    depth: z.coerce.number().int().min(1).max(3).optional().catch(undefined),
    limit: z.coerce.number().int().min(10).max(300).optional().catch(undefined),
    sim: z.boolean().optional().catch(undefined),
  }),
  component: ProvenanceScreen,
})
